import { render, staticRenderFns } from "./LabelPrice.vue?vue&type=template&id=4042e6c0&scoped=true"
import script from "./LabelPrice.vue?vue&type=script&lang=js"
export * from "./LabelPrice.vue?vue&type=script&lang=js"
import style0 from "./LabelPrice.vue?vue&type=style&index=0&id=4042e6c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4042e6c0",
  null
  
)

export default component.exports